(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nj-hero')) {
    customElements.define(
      'nj-hero',
      class NjHero extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('.nj-hero__toggle');
          this.videos = Array.from(this.querySelectorAll('video'));
          if (!this.videos.length) return;

          this.videos.forEach((video) => {
            video.muted = true;
            video.setAttribute('playsinline', '');
          });

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.pause();
          }

          if (this.toggle) {
            this.toggle.addEventListener('click', () => (this.paused ? this.play() : this.pause()));
          }
        }

        play() {
          this.paused = false;
          this.videos.forEach((video) => video.play().catch(() => {}));
          this.updateToggle();
        }

        pause() {
          this.paused = true;
          this.videos.forEach((video) => video.pause());
          this.updateToggle();
        }

        updateToggle() {
          if (!this.toggle) return;
          this.toggle.classList.toggle('is-paused', this.paused);
          this.toggle.setAttribute(
            'aria-label',
            this.paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nj-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nj-gallery')) {
    customElements.define(
      'nj-gallery',
      class NjGallery extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('video'));
          if (!this.videos.length) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.videos.forEach((video) => {
            video.muted = true;
            video.setAttribute('playsinline', '');
            if (reduceMotion) {
              video.removeAttribute('autoplay');
              video.pause();
            }
          });
          if (reduceMotion || !('IntersectionObserver' in window)) return;

          // Only play clips that are on screen.
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play().catch(() => {});
              } else {
                entry.target.pause();
              }
            });
          });
          this.videos.forEach((video) => this.observer.observe(video));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
